export const TestStringMaxLength = 100;